import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { ClientAccountClient } from "../../../../../../Wrap/Api/Account/ClientAccount";
import { IsaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/IsaContributionInstruction";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { GiaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/GiaContributionInstruction";
import { WrapCashContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/WrapCashContributionInstruction";
import { ExistingIndexationsDispatcher, ExistingRegularPaymentsDispatcher, RegularPaymentInstructionDispatcher, RegularPaymentInstructionStore } from "../Store/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { RegularPaymentActionType } from "../Resource/Contents";
import { BankAccountInstructionClient } from "../../../../../../Wrap/Api/BankAccounts/BankAccountInstruction";
import { BankAccountInstruction } from "../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { CheckRegularPaymentAutolineCompletedClient } from "../../../../../../Wrap/Api/Payments/CheckRegularPaymentAutolineCompleted";
import { RegularPaymentResult } from "../../../../../../Wrap/Models/Models/Payments/RegularPayment/RegularPaymentResult";
import { CashPayment } from "../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { IndexationClient } from "../../../../../../Wrap/Api/Payments/Indexation";
import { CashPaymentClient } from "../../../../../../Wrap/Api/PortfolioAnalysis/Payment/CashPayment";
import { CashPaymentTypeQuery } from "../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentTypeQuery";
import { CashPaymentFrequencyQuery } from "../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { PensionSubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionSubAccountAmendmentInstruction";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";

export class RegularPaymentAction {
    public static getInstruction(id, type, hierarchyId, subAccountHierarchyId, clientId, action): void {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            this.getOrCreateInstruction(
                pensionContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                action === "edit" ? "editregularpayment" :
                action === "add" ? "addregularpayment" :
                action
            );
        } else if (SubAccountTypeHelper.isPP(type)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            this.getOrCreateInstruction(
                giaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                action
            );
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const isaContributionInstruction = new IsaContributionInstructionClient();
            this.getOrCreateInstruction(
                isaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                action
            );
        } else if (SubAccountTypeHelper.isWrapCash(type)) {
            const wrapCashContributionInstruction = new WrapCashContributionInstructionClient();
            this.getOrCreateInstruction(
                wrapCashContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                action
            );
        }
    }

    public static saveInstruction(from, data: any, type, customerId: number, callback?: (data) => void): void {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            const promise = pensionContributionInstruction.put(data, customerId,null);
            this.updateRegularPaymentInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isPP(type)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            const promise = giaContributionInstruction.put(data, getQueryParameters()["action"]);
            this.updateRegularPaymentInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const client = new IsaContributionInstructionClient();
            const promise = client.put(data);
            this.updateRegularPaymentInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isWrapCash(type)) {
            const client = new WrapCashContributionInstructionClient();
            const promise = client.put(data);
            this.updateRegularPaymentInstructionStore(promise, callback);
        } else {
            callback([]);
        }
    }

    public static submitInstruction(id, data, customerId, claccountId, subAccountType, callback?: VoidFunction): void {
        const client = subAccountType === SubAccountType.Npr ? new PensionSubAccountAmendmentInstructionClient() : new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static getCashIsa(hierarchyId: string, callback?: VoidFunction): void {
        const client = new ClientAccountClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((result) => {
            const hasCashIsa = result.SubAccounts.some((ele) => ele.ProductDisplayName == "ISA Cash");
            RegularPaymentInstructionDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: hasCashIsa,
            });
            if (callback) {callback();}
        });
        promise.onError((err) => {
            RegularPaymentInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getExistingRegularPayments(subAccountHierarchyId: string) {
        const client = new CashPaymentClient();
        const promise = client.get(subAccountHierarchyId, CashPaymentTypeQuery.Deposit, CashPaymentFrequencyQuery.Regular);

        promise.onSuccess((data) => {
            ExistingRegularPaymentsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getIndexation(subAccountHierarchyId: string) {
        const client = new IndexationClient();
        const promise = client.get(subAccountHierarchyId);

        promise.onSuccess((data) => {
            ExistingIndexationsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    private static getOrCreateInstruction(
        client:
            | PensionContributionInstructionClient
            | IsaContributionInstructionClient
            | GiaContributionInstructionClient
            | WrapCashContributionInstructionClient,
        id,
        hierarchyId,
        subAccountHierarchyId,
        clientId,
        action
    ) {
        if (id && id !== "") {
            // Have instructionId
            const promise = client.get(id, clientId, action, null);
            this.updateRegularPaymentInstructionStore(promise);
        } else {
            // Create new instruction
            const promise = client.post(
                subAccountHierarchyId,
                hierarchyId,
                getQueryParameters()["action"] === RegularPaymentActionType.Edit
                    ? ActivityType.EditRegularPayment
                    : ActivityType.AddRegularPayment
            );
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const batchId = getQueryParameters()["batchid"];
                const model = client.get(instructionId, clientId, action, batchId);
                this.updateRegularPaymentInstructionStore(model);
            });

            promise.onError((err) => {
                RegularPaymentInstructionDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
        }
    }

    private static updateRegularPaymentInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(RegularPaymentInstructionStore.getData()));
            if (!data) {data = {};}
            data = result;
            RegularPaymentInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors);
            } else {
                callback(data);
            }
        });

        promise.onError((err) => {
            RegularPaymentInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static cancelBankAccountInstruction(
        bankAccountInstruction: BankAccountInstruction,
        callBack?: (val: BankAccountInstruction) => void
    ): void {
        const client = new BankAccountInstructionClient();
        const promise = client.delete(bankAccountInstruction);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }

    public static checkRegularPaymentAutolineCompleted(
        regularBuyId: number,
        callBack?: (result: RegularPaymentResult) => void
    ): void {
        const client = new CheckRegularPaymentAutolineCompletedClient();
        const promise = client.get(regularBuyId);
        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => {});
    }
}
